import { useEffect, useState } from "react";
import "../css/custom.css";
import ExpenseImage from "../img/m1.png"
import FormeLayout from "./FormeLayout";
import Header from "./Header";
import Table from "./Table";
import Swal from "sweetalert2";
import ExpenseModel from "../Models/ExpensModel";

function MainLayout(){

  // const expense =[];
// Handler issued by the child to receve the new expenses
  let [expense ,setExpenses]=useState([]);
  let onNewExpenseHandler =(newExpense)=>{
  //   // newExpense.id=expense.length+1;
  //   newExpense.id=Math.random();
  //   setExpenses((prevExpenses)=>{
  //   return [newExpense , ...prevExpenses]
  //  })
  //  console.log(newExpense); 
  saveExpensesOnFirebase(newExpense);
  }

  /////////////////////////
  let confirmDelete =() =>{
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire(
          'Deleted!', 
          'Your file has been deleted.',
          'success'
        )
      }
    })
   }///////////////////////
  // Handler issued by the child to performe delete
  let onDeleteExpenseHandler =(id)=>{
    // let filteredExpenses = expense.filter((elemente)=> elemente.id !=id);
    //   setExpenses(filteredExpenses);
    deleteExpensesOnFirebase(id);
  }
  let saveExpensesOnFirebase =(newExpense) => {
    fetch('https://vp-react-1-expenses-4b138-default-rtdb.firebaseio.com/expenses.json',
      {method : "POST",
      body : JSON.stringify(newExpense),
      headers :{
        "Content-Type" : "Application/json",
      },
      }
    )
    .then((response) =>{
      return response.json(); 
    })
    .then((result)=>{
      console.log(result.name);
      newExpense.id=result.name;
      setExpenses((prevExpenses)=>{
        return [newExpense , ...prevExpenses];
      });
    })
    .catch((error) =>{});

  } ;
  let fetchExpensesOnFirebase =() => {
    fetch(
      "https://vp-react-1-expenses-4b138-default-rtdb.firebaseio.com/expenses.json",
       {
        method : "GET",
       }
    )
    .then((response)=>{
      return response.json();
    })
    .then((result)=>{
      // console.log(result);
      let fbExpenses = [];
      for(let key in result){
        // console.log(key)
        // console.log(result[key]);
        let expense = new ExpenseModel(
          result[key].title,
          result[key].date,
          result[key].price,
          result[key].description
        );
          expense.id=key;
          fbExpenses.push(expense);
      }
      console.log(fbExpenses);
      setExpenses(fbExpenses);
    })
    .catch((error) =>{});
  };
  //اذا تم تغيير قيمة المتغير الى تروو سوف يتم جلب البيانات مرة اخرة 
  // let status =false;
  // useEffect(fetchExpensesOnFirebase,[status]);
   // fetchExpensesOnFirebase(); اذا وضعت زي هيك بصير انفنتي لوب 
  useEffect(fetchExpensesOnFirebase,[]); // الحل الصح لتجنب الانفنتي لوب 

  let deleteExpensesOnFirebase =(id) =>{
    fetch(
      `https://vp-react-1-expenses-4b138-default-rtdb.firebaseio.com/expenses/${id}.json`,
      {
        method :"DELETE",
      }
    )
    .then((response)=>{
      return response.json();
    })
    .then((result)=>{
      let filteredExpenses = expense.filter((elemente)=> elemente.id !=id);
      setExpenses(filteredExpenses);
      Swal.fire({
        title: "Deleted!",
        text: "Expenses Deleted Successfully!",
        icon: "success",
        showConfirmButton:false,
        timer: 2000,
      })
    })
    .catch((error)=>{})
  }
 
return (
  
    <div className="container mt-5">
    <div className="row">
      <div className="col-sm-6">
        <img src={ExpenseImage} className="img-fluid" alt=""/>
      </div>
      <div className="col-sm-6 mt-5">
      
      <Header></Header>
        <FormeLayout  /* the props As a  props */ onNewExpense={onNewExpenseHandler} />
      </div>
    </div>

   <Table expense={expense}
     deleteExpenseHandler ={onDeleteExpenseHandler}
   />
  </div>
)
}
export default MainLayout;